module.exports = __webpack_public_path__ + "static/media/pebbble4.5d4a0c6c.gif";